/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_Paper_TitleInputs */

const en_funnel_demo_paper_title = /** @type {(inputs: Funnel_Demo_Paper_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prospect Theory`)
};

const es_funnel_demo_paper_title = /** @type {(inputs: Funnel_Demo_Paper_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teoría prospectiva`)
};

/**
* | output |
* | --- |
* | "Prospect Theory" |
*
* @param {Funnel_Demo_Paper_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_paper_title = /** @type {((inputs?: Funnel_Demo_Paper_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_Paper_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_paper_title(inputs)
	return en_funnel_demo_paper_title(inputs)
});